import React from "react";
import LeasedEquipmentStatusTable from "./view/LeasedEquipmentStatusTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const LeasedEquipmentStatus = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_leasedequipment_status_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewPermission) ? (
        <LeasedEquipmentStatusTable />
      ) : (
        ""
      )}
    </>
  );
};

export default LeasedEquipmentStatus;
